module.exports = __webpack_public_path__ + "media/bootstrap-icons/whatsapp-bda05a39.svg";